import Api from "../../config/ApiConfig";
import { ISchemaSelection } from "./types";

const apiUrls = {
  //api/v1/sources/{src_id}/entities
  getSchemas: "api/v1/sources/",
};

export const getSchemaData = (src_id: number) =>
  Api.get<ISchemaSelection[]>(apiUrls.getSchemas + src_id + "/entities");
